import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { UserListHead } from 'src/sections/@dashboard/user';

const ScheduledReportGridHead = ({ scheduledList, order, orderBy, handleRequestSort }) => {
  const { t: translate } = useTranslation();

  const getTableDesk = [
    { id: 'scheduled', label: translate('scheduled_reports.scheduled_on'), alignRight: false, hasSort: true },
    { id: 'subject', label: translate('report.subject'), alignCenter: true, hasSort: true },
    { id: 'data_range', label: translate('scheduled_reports.data_range'), alignRight: false },
    { id: 'frequency', label: translate('scheduled_reports.frequency'), alignRight: false, hasSort: true },
    { id: 'group_by', label: translate('scheduled_reports.group_data_by'), alignRight: false, hasSort: true },
    { id: 'file_type', label: translate('scheduled_reports.file_type'), alignRight: false },
    { id: 'is_custom_report', label: translate('navbar.menu.custom_report'), alignRight: false },
    { id: 'recipient', label: translate('scheduled_reports.recipient'), alignCenter: true },
    { id: 'action', label: translate('common.action'), alignRight: false },
  ];
  const getTableMobile = [
    { id: 'scheduled-on', label: translate('scheduled_reports.scheduled_on'), alignRight: false, hasSort: true },
    { id: 'post-content', label: translate('scheduled_reports.post_content'), alignRight: false, hasSort: true },
    { id: 'action', label: translate('common.action'), alignRight: false },
  ];
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const TABLE_HEAD = isMobile ? getTableMobile : getTableDesk;

  return (
    <UserListHead
      order={order}
      orderBy={orderBy}
      headLabel={TABLE_HEAD}
      rowCount={scheduledList.length}
      onRequestSort={handleRequestSort}
      style={{ whiteSpace: 'nowrap' }}
      isShowCheckbox={false}
    />
  );
};

export default ScheduledReportGridHead;
